import { Box } from '@pets-ui/Box/Box'
import { Image } from '@pets-ui/Image/Image'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'

export interface CartItemImageProps {
  productTitle?: ReactNode
  productImgSrc?: string
  productImgWidth?: number
}

export const CartItemImage = (props: CartItemImageProps) => {
  const { productImgSrc, productTitle, productImgWidth = 80 } = props
  return (
    <Box position="relative" borderRadius={4} overflow="hidden">
      <Image
        src={productImgSrc}
        width={productImgWidth}
        fallback={<Box width={productImgWidth} height={productImgWidth} backgroundColor={colors.grey100} />}
        alt={`${productTitle} image`}
      />
    </Box>
  )
}
